"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withPopups = void 0;
var React = require("react");
var PopupContext_1 = require("./PopupContext");
/**
 adds popupManager to props
 */
function withPopups(managerName) {
    if (managerName === void 0) { managerName = 'popupManager'; }
    return function (WrappedComponent) {
        return function (props) {
            return (React.createElement(PopupContext_1.PopupContext.Consumer, null, function (context) {
                var _a;
                return (React.createElement(WrappedComponent, __assign({}, props, (_a = {}, _a[managerName] = context.popupManager, _a))));
            }));
        };
    };
}
exports.withPopups = withPopups;
//# sourceMappingURL=withPopups.js.map